<div class="property-label">
    <span class="label">{{label}}</span>
</div>
<div class="property-data">
    <span class="data">{{data}}</span>
</div>